// extracted by mini-css-extract-plugin
module.exports = {"filtersBtn":"Products_filtersBtn__sykkI","heading":"Products_heading__2evTd","wrapper":"Products_wrapper__Imz_D"};